import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PollingAsync from 'Components/Polling/PollingAsync';
import LeadDownloadAsync from './LeadDownloadAsync';
import { isEmpty } from 'Helpers/objects';

export const LeadDownloadQueuer = ({ displayList, fetchingList }) => {
    return ((displayList.length || !isEmpty(fetchingList)) && <PollingAsync>
        <LeadDownloadAsync />
    </PollingAsync>);
};

LeadDownloadQueuer.propTypes = {
    displayList: PropTypes.arrayOf(PropTypes.number),
    fetchingList: PropTypes.object
};

LeadDownloadQueuer.defaultProps = {
    displayList: [],
    fetchingList: {}
};

const mapStateToProps = state => ({
    displayList: state.leadDownloads.displayList,
    fetchingList: state.leadDownloads.isFetching
});

export default connect(mapStateToProps, null)(LeadDownloadQueuer);
